import { ColorPickerField } from '../../components/ColorPickerField';
import { IconField } from '../../components/IconField';
import { useIcon } from '../../Hooks/useIcon';
import slate from '../../packages/plugins/content/slate';

const defaultSlate = slate();

// use a type here, not an interface
// type Data = {
//   title: string,
//   style: {
//     padding: number;
//     icon: string;
//     iconBackground: string;
//     iconColor: string;
//     bgColor: string;
//     textColor: string;
//   };
// }

const sidebarLinkPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div className={'sidebar-link-root'}>
      <div
        className="sidebar-link-outer-bg"
        style={{
          backgroundColor: data?.style?.bgColor
            ? data?.style?.bgColor
            : 'white',
          padding: data?.style?.padding,
        }}
      >
        <div
          className="sidebar-link-icon"
          style={{
            backgroundColor: data?.style?.iconBackground
              ? data?.style?.iconBackground
              : '#fff',
          }}
        >
          <TitleIcon
            color={data?.style?.iconColor}
            iconName={data?.style?.icon}
          />
        </div>
        <div
          className="sidebar-link-text"
          style={{ color: data?.style?.textColor ?? 'black' }}
        >
          {children}
        </div>
      </div>
    </div>
  ),
  childConstraints: {
    maxChildren: 1,
  },
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h2,
                children: ['Link Text'],
              },
            ],
          })),
        },
      ],
    ];
  },
  id: 'sidebarLinkPlugin',
  title: 'Sidebar Link',
  description: 'Sidebar Link with a customizable icon',
  version: 1,
  controls: [
    {
      title: 'Default Config',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            title: {
              type: 'string',
              default: 'Title',
            },
          },
          required: ['title'],
        },
      },
    },
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                icon: {
                  type: 'string',
                  default: 'Anchor 2',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,0.8)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'black',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
                bgColor: {
                  type: 'string',
                  default: '#fff',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Background Color: ',
                  },
                },
                padding: {
                  type: 'number',
                  default: 10,
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default sidebarLinkPlugin;

function TitleIcon(props: any) {
  const Icon = useIcon(props);
  return Icon;
}
